import PropTypes from "prop-types";
import { InputAdornment, TextField, Typography } from "@material-ui/core";
import { NumericFormat } from "react-number-format";
import { BillingInstallmentPropTypes, formatInputValuesToDefault, formatNumber } from "../../../utils/financialHelper";

const InstallmentList = ({ installments, setValues }) => {
  const handleInstallmentChange = (index, field, value) => {
    setValues(prevValues => {
      const updatedInstallments = [...prevValues.billingInstallments];
      updatedInstallments[index] = {
        ...updatedInstallments[index],
        [field]: formatInputValuesToDefault(value),
      }

      return {
        ...prevValues,
        billingInstallments: updatedInstallments,
      }
    })
  }

  return (
    <>
      <Typography variant="overline">Parcelas</Typography>

      {installments && installments.map((installment, index) => {
        if (!installment?.installmentNumber) {
          // First render undefined installment
          return (<></>)
        }
        return (
          <div className='linha-campos' key={`installment_${installment.installmentNumber}`}>
            <TextField
              label="Parcela Nº"
              value={installment.installmentNumber}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              disabled
              margin="dense"
            />

            <TextField
              label="Data de Vencimento"
              value={installment.dueDate}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              disabled
              margin="dense"
              type='date'
            />

            <NumericFormat
              customInput={TextField}
              label="Valor da Parcela"
              id='amount'
              name='amount'
              value={installment.amount ?? ''}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              }}
              fullWidth
              disabled
              decimalSeparator=","
              decimalScale={2}
              autoComplete="off"
              margin="dense"
            />

            <NumericFormat
              customInput={TextField}
              label="Valor"
              id='amountPayed'
              name='amountPayed'
              value={installment.amountPayed ?? ''}
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              }}
              fullWidth
              decimalSeparator=","
              decimalScale={2}
              autoComplete="off"
              onChange={(e) => handleInstallmentChange(index, 'amountPayed', e.target.value)}
              margin="dense"
            // required={paymentFieldsRequired}
            />

            <TextField
              id='paymentDate'
              name='paymentDate'
              label="Data de Pagamento"
              value={installment.paymentDate || ''}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              margin="dense"
              type="date"
              onChange={(e) => handleInstallmentChange(index, 'paymentDate', e.target.value)}
            // required={paymentFieldsRequired}
            />
          </div>

        )
      })}
    </>

  )
}

InstallmentList.propTypes = {
  installments: PropTypes.arrayOf(PropTypes.shape(BillingInstallmentPropTypes)).isRequired,
  setValues: PropTypes.func.isRequired,
}

export default InstallmentList